import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyAjHut_L9bfwnEe3ZCr8PK7opGfXIlXsIk",
  authDomain: "trading-app-55395.firebaseapp.com",
  projectId: "trading-app-55395",
  storageBucket: "trading-app-55395.firebasestorage.app",
  messagingSenderId: "241178208081",
  appId: "1:241178208081:web:ab05aca4c854201b5d1570",
  databaseURL: "https://trading-app-55395-default-rtdb.asia-southeast1.firebasedatabase.app" // Correct URL
};

const app = initializeApp(firebaseConfig);
const db = getDatabase(app); 

export { db }; // Named export use karein
export default app;